import React from "react";
import RubyQuickFixesWidget from "./RubyQuickFixesWidget";

interface AskRubyWidgetProps {
  onAuditComplete?: (result: unknown) => void;
  activeTab?: string;
  initialAuditResult?: unknown;
  onIssueFixed?: () => void;
}

/** Search Intelligence — Quick Fixes chat (Authority44 data, no audit shortcuts). */
const AskRubyWidget: React.FC<AskRubyWidgetProps> = ({ activeTab = "overview", onIssueFixed }) => (
  <RubyQuickFixesWidget
    cardId="search-intelligence"
    activeTab={activeTab}
    onIssueFixed={onIssueFixed}
  />
);

export default AskRubyWidget;
